module.exports = __webpack_public_path__ + "assets/img/bg-e2eae19a.jpg";